import { cookieManagerInstance } from "../cookies";
import {
  CustomCookieIdentifier,
  DEFAULT_CROSS_PORTAL_COOKIE_OPTIONS,
} from "../constants/ShortbreadConfig";

/**
 * Get the Tutorial cookie and return a boolean.
 * If no cookie is found, return false.
 * For EU customer who doesn't have consent to functional cookie, return true to avoid tutorial showing up every time.
 */
export const getTutorialCookie = (): boolean => {
  try {
    const tutorialCookie = JSON.parse(
      cookieManagerInstance.getCookieStorage(
        CustomCookieIdentifier.TUTORIAL.name
      )
    ); // this will convert string to boolean if exists
    return tutorialCookie ?? false;
  } catch {
    return false;
  }
};

/**
 * Set the Tutorial cookie as true if tutorial is finished by user.
 */
export const setTutorialCookie = (isFinished: boolean) => {
  cookieManagerInstance.setCookieStorage(
    CustomCookieIdentifier.TUTORIAL.name,
    isFinished.toString(), // cookie value is string type
    DEFAULT_CROSS_PORTAL_COOKIE_OPTIONS
  );
};
